export const triggerGoal = async (id: string | undefined, onTileRefresh?: () => void) => {
  if (id && id !== '00000000-0000-0000-0000-000000000000') {
    //dont trigger goal on empty guid
    await fetch(`/-/media/Project/Safeco/shared/website-artifacts/logos/goal_trigger?sc_trk=${id}`, {
      method: 'GET',
      cache: 'no-store',
    }).then(() => {
      onTileRefresh && onTileRefresh();
    });
  }
};

export const configureGoalManager = () => {
  //configure links with goal attributes to trigger goals on click, ignore custom data tags
  attachGoalsToLinks(document.querySelectorAll<HTMLLinkElement>('a[goal]:not([data-function])'));
};

export const attachGoalsToLinks = (links: NodeListOf<HTMLLinkElement>, onTileRefresh?: () => void) => {
  if (links)
    for (let j = 0; j < links.length; j++)
      if (!links[j].onclick) {
        links[j].onclick = () => {
          triggerGoal(links[j].getAttribute('goal') ?? '', onTileRefresh);
        };
      }
};
